import React, { Component } from 'react';
import ReactExport from 'react-export-excel';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../../adminStyles';
import { Button, IconButton, SvgIcon } from '@material-ui/core';
import {
  notify
} from '../../../../redux/utils/notifications/notifications';

export default function ExportToExcelButton(props) {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const user = useSelector(state => state.users.all);
  const { btnMobile2 } = useStyles();
  const { columns, rows, approveBtn, searchTerm, employeeType,isRecSelected } = props;
  const exportModifiedObj=()=>{
    let modifiedObj=[];
    rows.forEach(user => {
      if (user.isChecked) {
        if((user.details||[]).length>0)
        user.note=user.details[0].note;
        modifiedObj.push(user);
        if((user.details||[]).length>0)
        (user.details||[]).forEach((val,index) => {
          if(index!=0){
            modifiedObj.push({ 
              details:user.tasks||[],
              emailId: "",
              userName: "",
              empType: "",
              empId: "",
              sickHrs: "",
              vacationHrs: "",
              holidayHrs: "",
              regularHrs: "",
              bereavementHrs:"",
              totalHrs: "",
              note:val.note
            });
          }
        });
      }
    });
    return modifiedObj;
  }
if (!isRecSelected) {
  return(<Button  className={btnMobile2} variant='contained' onClick={()=>{notify('warning',"Please select atleast one employee.")}}>
          Summary Report
        </Button>)
} else {
  return (
    <ExcelFile
      element={
        <Button className={btnMobile2} variant='contained'>
          Summary Report
        </Button>
      }
    >
      <ExcelSheet
        data={exportModifiedObj()}
        name='Projects Summary'
      >
        <ExcelColumn label='Emp. Id' value='empId' />
        <ExcelColumn label='Name' value='userName' />
        <ExcelColumn label='Employee Type' value='empType' />
        <ExcelColumn label='EmailId' value='emailId' />
        <ExcelColumn label='Regular Hrs' value='regularHrs' />
        <ExcelColumn label='Sick Hrs' value='sickHrs' />
        <ExcelColumn label='Vacation Hrs' value='vacationHrs' />
        <ExcelColumn label='Holiday Hrs' value='holidayHrs' />
        <ExcelColumn label='bereavement Hrs' value='bereavementHrs' />
        <ExcelColumn label='Total Hrs' value='totalHrs' width={100} />
        <ExcelColumn label='Task/note' value='note' width={100} />
      </ExcelSheet>
    </ExcelFile>
  );
}
  
}
